'use-client';
import {
  BackArrow,
  GoogleCalendarIconSetting,
  ICloudIconList,
  OutLookCircle,
  OutlookIcon,
} from '@mybridge/icons';
import {
  Flex,
  Heading,
  useDisclosure,
  Spinner,
  Box,
  HStack,
} from '@mybridge/ui';
import { Button } from '@mybridge/ui/button';
import { Input } from '@mybridge/ui/input';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Text } from '@mybridge/ui/text';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getGoogleIntegrationUrl,
  getOutlookIntegrationUrl,
  getGoogleIntegrationCallback,
  getConnectedCalendarList,
  getZoomIntegrationCallback,
  getOutlookIntegrationCallback,
} from 'packages/mybridgev4/store/slices/settingsSlice.js';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCalendarIntegrationURL,
  getIntegrationURL,
} from 'v4/lib/api/google-integration';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { useRouter } from 'next/router';
import { useToast } from '@mybridge/ui';
import { isMobile } from 'react-device-detect';
// import CalendarIntegration from './CalendarCards';
import CalendarDetails from './CalendarDetails';
import CalendarIntegration from './CalendarCards';

// import {
//   CheckGreenIcon,
//   GoogleCalendarIcon,
//   GoogleCalendarIconSetting,
//   ICloudIconList,
//   OutLookIcon,
// } from '@mybridge/icons';
import { ExchangeIcon } from '@mybridge/icons/ExchangeIcon';
import CheckConflictsModal from './CheckConflicts';
import CalendarConfiguration from './CalendarConfiguration';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export default function Calendar({ setSelectedComponent }) {
  const dispatch = useDispatch();
  const router = useRouter();
  const toast = useToast();
  const { t } = useTranslator();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const { calendarList } = useSelector((state) => state.settings);
  const { loggedIn } = useSelector((state) => state.user);

  const [modalOpen, setModalOpen] = useState(false);
  const [heading, setHeading] = useState(null);
  const [googleLinked, setGoogleLinked] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isConflictModalOpen, SetIsConflictModalOpen] = useState(false);

  const [isOpenDetailedView, setIsopenDetailedView] = useState('');

  const [calendars, setCalendars] = useState([
    {
      icon: <GoogleCalendarIconSetting />,
      title: t('settingsIntegration.googleCalendar') || 'Google Calendar',
      key: 'google',
      description: t('settingsIntegration.addEvents') || 'Add events to your calendar and prevent double-booking.',
      isConnected: false,
    },
    {
      icon: <OutLookCircle />,
      title: t('settingsIntegration.outlookCalendar') || 'Outlook Calendar',
      key: 'microsoft',
      description: t('settingsIntegration.addEvents') || 'Add events to your calendar and prevent double-booking.',
      isConnected: false,
    },
    {
      icon: <ICloudIconList />,
      title: t('settingsIntegration.iCloudCalendar') || 'iCloud Calendar',
      key: 'iCloud',
      description: t('settingsIntegration.addEvents') || 'Add events to your calendar and prevent double-booking.',
      isConnected: false,
    },
    {
      icon: <ExchangeIcon />,
      title: t('settingsIntegration.exchangeCalendar') || 'Exchange Calendar',
      key: 'exchange',
      description: t('settingsIntegration.addEvents') || 'Add events to your calendar and prevent double-booking.',
      isConnected: false,
    },
  ]);

  const handleGetCalendarList = () => {
    // if(loggedIn){
    dispatch(getConnectedCalendarList()).then((res) => {
      setCalendars((prevCalendars) =>
        prevCalendars.map((calendar) => {
          // Check if the calendar provider exists in the connected data
          const isConnected = res?.payload?.some(
            (connected) => connected.provider.toLowerCase() === calendar.key
          );
          return { ...calendar, isConnected };
        })
      );
    });
    // }
  };

  useEffect(() => {
    setTimeout(() => {
    handleGetCalendarList();
      
    }, 4000);
    // handleGetCalendarList();
  }, []);

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      router?.query?.code &&
      !router?.query?.scope &&
      router?.query?.slug?.includes('outlook')
    ) {
      // Ensure code runs only on client-side
      const payload = {
        state: router?.query?.state,
        code: router?.query?.code,
        prompt: router?.query?.prompt,
        authuser: router?.query?.authuser,
        hd: router?.query?.hd,
      };
      dispatch(getOutlookIntegrationCallback(payload)).then((res) => {
        toast({
          title: 'Success',
          description: res?.payload?.data,
          status: 'success',
          duration: 9000,
          isClosable: true,
        });
        handleGetCalendarList();
        // Check if redirectToScheduleMeet is set in localStorage
        if (typeof window !== 'undefined' && localStorage.getItem('redirectToScheduleMeet') === 'true') {
          // localStorage.removeItem('redirectToScheduleMeet');
          router.push('/profile/calendar/schedule');
        } else if (typeof window !== 'undefined' && localStorage.getItem('redirectToCreateAppointment') === 'true') {
          router.push('/profile/calendar/appointments');
        } else if (typeof window !== 'undefined' && localStorage.getItem('redirectToScheduleEvent') === 'true') {
          // Get the stored path and redirect back to the event form
          const eventPath = localStorage.getItem('redirectToScheduleEventPath') || '/myevents/create';
          localStorage.removeItem('redirectToScheduleEvent');
          localStorage.removeItem('redirectToScheduleEventPath');
          // Note: redirectToScheduleEventType will be cleaned up by choose-event.js if path is choose-event
          // For other paths, we clean it up here
          if (!eventPath.includes('choose-event')) {
            localStorage.removeItem('redirectToScheduleEventType');
          }
          router.push(eventPath);
        // } else {
        //   router.push('/settings/integration?status=success');
        // }
        } else if (typeof window !== 'undefined' && localStorage.getItem('redirectToCalendar') === 'true') {
          localStorage.removeItem('redirectToCalendar');
          router.push('/profile/calendar');
        } else {
          router.push('/settings/integration?status=success');
        }
      });
    }
  }, [router]);
  return (
    <AuthenticatedProviders>
      <Box w="100%" className="user-settings--integration">
        <Box>
          {!isMobile && (
            <Heading as="h4" size="md" p={['10px', '0 0 10px']}>
              <HStack>
                {' '}
                {isMobile && (
                  <BackArrow onClick={() => setSelectedComponent()} />
                )}{' '}
                <Text color="#3D5A80" fontWeight={'normal'}>
                  {t('settingsIntegration.allIntegrations') || "All Integrations"}
                </Text>
              </HStack>
            </Heading>
          )}

          {!isOpenDetailedView && (
            <CalendarIntegration
            setSelectedComponent ={setSelectedComponent}
              calendars={calendars}
              setIsopenDetailedView={setIsopenDetailedView}
              isMoible={isMobile}
            />
          )}
          { isOpenDetailedView && <CalendarDetails />}

          {!isOpenDetailedView && (
            <Box>
              <Heading as="h4" size="md" p={['10px', '0 0 10px']} my="5%">
                <HStack>
                  {' '}
                  {isMobile && (
                    <BackArrow onClick={() => setSelectedComponent()} />
                  )}{' '}
                  <Text color="#3D5A80" fontWeight={'normal'}>
                    {t('settingsIntegration.configuration') || "Configuration"}
                  </Text>
                </HStack>
              </Heading>
              {!isMobile && (
                <CalendarConfiguration
                  handleGetCalendarList={handleGetCalendarList}
                  calendars={calendars}
                  calendarList={calendarList}
                />
              )}
            </Box>
          )}

          {/* <Box>
            <Box
              p={['0 10px', 0]}
              {...(googleLinked
                ? {
                    'aria-label': 'Already linked!',
                    'data-microtip-position': 'top',
                    role: 'tooltip',
                  }
                : {})}
            >
              <Button
                variant={
                  userProfileInfo?.google_calendar_email === null
                    ? 'primary'
                    : 'secondary'
                }
                // isDisabled={!googleIntLink}
                onClick={() => {
                  if (userProfileInfo?.google_calendar_email) {
                    setHeading('google');
                    setModalOpen((prevState) => !prevState);
                  } else {
                    mutate();
                  }
                }}
              >
                {isLoading ? (
                  <Spinner />
                ) : (
                  <>
                    <GoogleCalendarIcon
                      width="18px"
                      color={
                        userProfileInfo?.google_calendar_email === null
                          ? 'white'
                          : 'green'
                      }
                    />
                    <Text
                      ms="10px"
                      color={
                        userProfileInfo?.google_calendar_email === null
                          ? 'white'
                          : 'grey'
                      }
                    >
                      {userProfileInfo?.google_calendar_email
                        ? `Integrated with ${userProfileInfo?.google_calendar_email}`
                        : 'Google Calendar'}
                    </Text>
                  </>
                )}
              </Button>
            </Box> 
          </Box>*/}
        </Box>

        {/* <Box>
          <Box p={['0 10px', 0]}>
            <Heading as="h4" size="md" mt="30px" mb="10px">
              Personal Contacts
            </Heading>
            <Text>See who you already know</Text>
            <Text my="10px">
              Syncing your contacts is the fastest way to grow your network.
              We&apos;ll periodically import and store your contacts to help you
              and others connect. You choose who to connect to and who to
              invite.
            </Text>
          </Box>
          <Flex gap="4" mb={[5, 0]} p={['0 10px', 0]}>
            <Input type="text" placeholder="Email" />
            <Button size="lg" onClick={() => handleClick()} variant="primary">
              Continue
            </Button>
          </Flex>
        </Box>

        <Modal
          isOpen={modalOpen && heading === 'google'}
          onClose={() => setModalOpen(false)}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Calendar Integration</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              You have synced your Google and myBridge calendars
            </ModalBody>

            <ModalFooter>
              <Button variant="primary" onClick={() => setModalOpen(false)}>
                OK
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal
          isOpen={modalOpen && heading === 'contacts'}
          onClose={() => setModalOpen(false)}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Syncing your contact</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              You're good to go, your contacts have been have synced
            </ModalBody>

            <ModalFooter>
              <Button variant="primary" onClick={() => setModalOpen(false)}>
                OK
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal> */}
      </Box>
    </AuthenticatedProviders>
  );
}
